import React, { Component } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import UndoIcon from '@material-ui/icons/Undo'
import PropTypes from 'prop-types'

export class DestroyButton extends Component {
  static defaultProps = {
    onDestroy: () => {}
  }

  handleDestroy = () => {
    const destory = !this.props.value
    this.props.onChange({target: {value: destory}})
    this.props.onDestroy(destory)
  }

  render = () => {
    return (
      <IconButton onClick={this.handleDestroy} color="primary" aria-label="Remove">
        {
          !!this.props.value ? <Tooltip title='Restore'><UndoIcon/></Tooltip> : <Tooltip title='Delete'><DeleteIcon/></Tooltip>
        }
      </IconButton>
    )
  }
}


DestroyButton.displayName = 'DestroyButton';

DestroyButton.defaultProps = {
  value: undefined
};

DestroyButton.propTypes = {
    /** This comment will be visible in the Storybook PropTypes table */
    value: PropTypes.string,
    /** This comment will be visible in the Storybook PropTypes table */
    onChange: PropTypes.func,
     /** This comment will be visible in the Storybook PropTypes table */
    onDestroy: PropTypes.func
};

export default DestroyButton